import { render, staticRenderFns } from "./TokenView.vue?vue&type=template&id=08689fd7&scoped=true&"
import script from "./TokenView.vue?vue&type=script&lang=js&"
export * from "./TokenView.vue?vue&type=script&lang=js&"
import style0 from "./TokenView.vue?vue&type=style&index=0&id=08689fd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08689fd7",
  null
  
)

export default component.exports